"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatToReferencesList = void 0;

var _always = _interopRequireDefault(require("transmute/always"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _immutable = require("immutable");

var formatToReferencesList = (0, _curry.default)(function (_ref, items) {
  var getId = _ref.getId,
      getLabel = _ref.getLabel,
      _ref$getIcon = _ref.getIcon,
      getIcon = _ref$getIcon === void 0 ? (0, _always.default)(undefined) : _ref$getIcon,
      _ref$getDescription = _ref.getDescription,
      getDescription = _ref$getDescription === void 0 ? (0, _always.default)(undefined) : _ref$getDescription,
      _ref$getDisabled = _ref.getDisabled,
      getDisabled = _ref$getDisabled === void 0 ? (0, _always.default)(undefined) : _ref$getDisabled;
  return (0, _immutable.List)(items.map(function (value) {
    return new _ReferenceRecord.default({
      id: String(getId(value)),
      label: getLabel(value),
      icon: getIcon(value),
      description: getDescription(value),
      referencedObject: (0, _immutable.fromJS)(value),
      disabled: getDisabled(value)
    });
  }));
});
exports.formatToReferencesList = formatToReferencesList;